import BaseDataStore from '@/components/base/store/BaseDataStoreV1'

const BaseConst = {
  version: 1,
  storeName: 'C2201ProjectInvestmentTargetInvestor',
  serviceName: 'C2201ProjectInvestmentTargetInvestor'
}
const C2201Const = new BaseDataStore(BaseConst)
export default C2201Const
